import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { noop } from 'ui-components/default-props/noop';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../modals/order-details-modal/event-tracking/use-track-order-details-action';

import style from './customer-recipient-widget.module.less';

const DisabledEditTooltip = () => {
  return (
    <Tooltip>
      <div className={style['information-icon']}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </div>
      <TooltipContent>
        <div className={style['tooltip-header']}>
          <FormattedMessage
            defaultMessage='Editing for this order is disabled.'
            description='shipTo.disableEdit.tooltipHeader'
            id='s+zYQx'
          />
        </div>
        <FormattedMessage
          defaultMessage='This type of delivery must go to the address below.'
          description='shipTo.disableEdit.tooltipContent'
          id='Y55e0j'
        />
      </TooltipContent>
    </Tooltip>
  );
};

/**
 * @param {object} props
 * @param {() => void}props.setEditMode
 * @param {boolean} props.showHeader
 * @param {boolean} props.disableEdit
 * @param {string} props.linkContainerClassName
 * @returns {JSX.Element}
 */
const EditShipToLink = ({ setEditMode = noop, showHeader = false, disableEdit = false, linkContainerClassName }) => {
  const sidebarClass = !showHeader ? style['edit-link-sidebar'] : '';
  const trackEditOrderRecipient = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.EDIT_ORDER_RECIPIENT);

  const onClick = useCallback(() => {
    setEditMode();
    trackEditOrderRecipient();
  }, [setEditMode, trackEditOrderRecipient]);

  return (
    <div className={classnames(style['edit-link'], sidebarClass, linkContainerClassName)}>
      {disableEdit && DisabledEditTooltip()}
      <Button className={style['edit-link-button']} disabled={disableEdit} onClick={onClick} theme='link'>
        <FormattedMessage defaultMessage='Edit' description='shipTo.edit' id='2Cq5P2' />
      </Button>
    </div>
  );
};

export default EditShipToLink;
